export default __webpack_public_path__ + "static/media/Slide24.ec334866.PNG";